<template>
  <page>
        <div>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 lg6 xl6>
                          <cal-picker
                            v-model="form.uploadDate_from"
                            :label="labels.uploadDate_from"
                            v-validate="uploadDate_from_Validation()"
                            :data-vv-as="labels.uploadDate_from"
                            data-vv-name="uploadDate_from"
                            :error-messages="errors.collect('uploadDate_from')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg6 xl6>
                          <cal-picker
                            v-model="form.uploadDate_to"
                            :label="labels.uploadDate_to"
                            v-validate="uploadDate_to_Validation(form.uploadDate_from)"
                            :data-vv-as="labels.uploadDate_to"
                            data-vv-name="uploadDate_to"
                            :error-messages="errors.collect('uploadDate_to')"
                            :min="this.form.uploadDate_from"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 lg6 xl6>
                          <cal-picker
                            v-model="form.downloadDate_from"
                            :label="labels.downloadDate_from"
                            v-validate="downloadDate_from_Validation()"
                            :data-vv-as="labels.downloadDate_from"
                            data-vv-name="downloadDate_from"
                            :error-messages="errors.collect('downloadDate_from')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg6 xl6>
                          <cal-picker
                            v-model="form.downloadDate_to"
                            :label="labels.downloadDate_to"
                            v-validate="downloadDate_to_Validation(form.downloadDate_from)"
                            :data-vv-as="labels.downloadDate_to"
                            data-vv-name="downloadDate_to"
                            :error-messages="errors.collect('downloadDate_to')"
                            :min="this.form.downloadDate_from"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-3"></v-spacer>
                <v-flex xs12 sm12 md12 lg12>
                    <v-btn color="primary" dark class=" mr-2" @click="doSend">
                      <v-icon>mdi-delete</v-icon>
                      Purge
                    </v-btn>
                </v-flex>
        </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      uploading: false,
      labels: {
        uploadDate_from: 'Upload Date From',
        uploadDate_to: 'Upload Date To',
        downloadDate_from: 'Download Date From',
        downloadDate_to: 'Download Date To'
      },
      form: {
        uploadDate_from: undefined,
        uploadDate_to: undefined,
        downloadDate_from: undefined,
        downloadDate_to: undefined
      },
      uploadDownloadSwitch: '',
      panel: [0]
    }
  },
  watch: {
    'form.uploadDate_from'(newVal, oldVal) {
      if (newVal && newVal !== '') {
        this.uploadDownloadSwitch = 'upload'
        this.form.downloadDate_from = ''
        this.form.downloadDate_to = ''
      }
    },
    'form.uploadDate_to'(newVal, oldVal) {
      if (newVal && newVal !== '') {
        this.uploadDownloadSwitch = 'upload'
        this.form.downloadDate_from = ''
        this.form.downloadDate_to = ''
      }
    },
    'form.downloadDate_from'(newVal, oldVal) {
      if (newVal && newVal !== '') {
        this.uploadDownloadSwitch = 'download'
        this.form.uploadDate_from = ''
        this.form.uploadDate_to = ''
      }
    },
    'form.downloadDate_to'(newVal, oldVal) {
      if (newVal && newVal !== '') {
        this.uploadDownloadSwitch = 'download'
        this.form.uploadDate_from = ''
        this.form.uploadDate_to = ''
      }
    }
  },
  methods: {
    async doSend() {
      if (this.uploadDownloadSwitch.length <= 1) {
        this.$toast.error('User must enter either Upload Date range OR Download Date range, not both')
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.doSendRequest()
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    async doSendRequest() {
      const dto = []
      dto.push({
        uploadDownloadSwitch: this.uploadDownloadSwitch,
        uploadDate_from: this.form.uploadDate_from,
        uploadDate_to: this.form.uploadDate_to,
        downloadDate_from: this.form.downloadDate_from,
        downloadDate_to: this.form.downloadDate_to,
        format: 'PDF',
        sendEmail: false
      })
      const apiURI = this.$store.state.underwriting.dataTransferSettings.menu.purgeVehDetReq
      if (apiURI) {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      } else {
        this.$toast.error('Request Mapping Not Found!')
      }
    },
    uploadDate_from_Validation() {
      if (this.uploadDownloadSwitch === 'upload') {
        return 'required'
      } else if (this.uploadDownloadSwitch === 'download') {
        return ''
      } else {
        return ''
      }
    },
    uploadDate_to_Validation(uploadDateFrom) {
      if (this.uploadDownloadSwitch === 'upload') {
        return 'required|from_to_date:' + uploadDateFrom
      } else if (this.uploadDownloadSwitch === 'download') {
        return ''
      } else {
        return ''
      }
    },
    downloadDate_from_Validation() {
      if (this.uploadDownloadSwitch === 'upload') {
        return ''
      } else if (this.uploadDownloadSwitch === 'download') {
        return 'required'
      } else {
        return ''
      }
    },
    downloadDate_to_Validation(downloadDateFrom) {
      if (this.uploadDownloadSwitch === 'upload') {
        return ''
      } else if (this.uploadDownloadSwitch === 'download') {
        return 'required|from_to_date:' + downloadDateFrom
      } else {
        return ''
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit')
    }
  },
  mixins: [MessageMixin]
}
</script>
